import { CustomAxiosHeaders } from '../config/services'
import config from '../config'
import { requests } from '.'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'FunnelServices'
const host = config.funnelsApiURL
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}
interface ListFunnelProducts {
  locationId: string
  funnel: string
  step: string
}

interface GetTransactions {
  locationId: string
  offset: number
  limit:number
}

interface InvalidateCacheParams {
  locationId: string
  domains: Array<string>
  event: string
}

interface ClearFunnelCacheParams {
  domains: Array<string>
  paths?: Array<string>
}

interface GetFunnelsParams {
  locationId: string
  type?: string
  category?: string
  offset?: string
  parentId?: string
  name?: string
}

interface GetFunnelPagesByStepParams {
  locationId: string
  stepId: string
}

interface CloneFunnelToLocations {
  funnelId: string
  funnelName: string
  locationIds: string[]
}

export enum ShareWithType {
  ALL = 'ALL',
  AGENCY = 'AGENCY',
  REMOVE = 'REMOVE'
}

interface ShareFunnelResponse {
  funnelName?: string
  funnelId?: string
  funnelType?: string
  dateAdded?: Date
  dateUpdated?: Date
  companyId?: string
  shareWith?: string
}

interface FunnelResponse {
  steps: Step[]
  globalFonts: any[]
  deleted: boolean
  _id: string
  dateAdded: string
  dateUpdated: string
  domainId: string
  faviconUrl: string
  globalSectionsPath: string
  globalSectionsUrl: string
  isChatWidgetLive: boolean
  locationId: string
  name: string
  orderFormVersion: number
  processing: boolean
  trackingCodeBody: string
  trackingCodeHead: string
  type: string
  url: string
  updatedAt: string
  globalSectionVersion: number
}

export interface Step {
  id: string
  name: string
  pages: string[]
  products: any[]
  sequence: number
  type: string
  url: string
}

const FunnelsServices = {
  getById: (id: string) => request().get<{data:FunnelResponse}>(`/funnels/funnel/fetch/${id}`),
  listFunnelProducts: (params: ListFunnelProducts) =>
    request().get('/funnels/order-form/products', {
      params,
    }),
  getTransactions: (params:GetTransactions) =>
    request().get(`/funnels/transaction/list`, { params }),
  invalidateCache: (params:InvalidateCacheParams) =>
    request().post(`/funnels/domain/invalidate-cache`, params),
  fetchFunnels: (params:GetFunnelsParams) =>
    request().get(`/funnels/funnel/list`, { params }),
  getFunnelPagesByStepId: (params:GetFunnelPagesByStepParams) =>
    request().get(`/funnels/funnel/step/pages`, { params }),
  cloneFunnelToLocations: (params: CloneFunnelToLocations) =>
    request().post('/funnels/funnel/clone-funnel-to-locations',params),
  getShareFunnelById:(shareId:string) : Promise<{data:{data:ShareFunnelResponse}}> =>
    request().get(`/funnels/builder/funnel-share-url/${shareId}`),
  getPageById: (pageId: string) => 
    request().get(`/funnels/page/${pageId}`),
  clearFunnelCache: (params: ClearFunnelCacheParams) =>
    request().post(`/funnels/funnel/cache/clear`, params)
}

export default FunnelsServices
